import classNames from 'classnames';
import styles from '../footerSectionWrapper/FooterSectionWrapper.module.css';

export const FooterSectionWrapper = ({
    className,
    innerWrapperClassName,
    children
}: {
    className?: string;
    innerWrapperClassName?: string;
    children: React.ReactNode;
}) => {
    return (
        <div className={classNames(styles.FooterSectionWrapper, className)}>
            <div
                className={classNames(
                    styles.wrapperInner,
                    innerWrapperClassName
                )}
            >
                {children}
            </div>
        </div>
    );
};
